import { z } from 'zod';

/** One published configuration version of a project (functional §5.7, technical §7.1). */
export const configurationReleaseDto = z
  .object({
    version: z.number().int().min(1),
    isActive: z.boolean(),
    guidanceCount: z.number().int().min(0),
    publishedAt: z.string().datetime(),
    /** Account identifier of the publisher; null for releases written before audit existed. */
    publishedBy: z.string().uuid().nullable(),
  })
  .strict();
export type ConfigurationReleaseDto = z.infer<typeof configurationReleaseDto>;
